"use client";
const d = "ArrowUp", h = "ArrowDown", R = "ArrowLeft", T = "ArrowRight", a = "Home", g = "End", M = /* @__PURE__ */ new Set([R, T]), _ = /* @__PURE__ */ new Set([R, T, a, g]), P = /* @__PURE__ */ new Set([d, h]), w = /* @__PURE__ */ new Set([d, h, a, g]), E = /* @__PURE__ */ new Set([...M, ...P]), H = /* @__PURE__ */ new Set([...E, a, g]), I = /* @__PURE__ */ new Set([d, h, R, T, a, g]), A = "Shift", O = "Control", u = "Alt", W = "Meta", Y = /* @__PURE__ */ new Set([A, O, u, W]);
function F(t) {
  return t instanceof HTMLInputElement && t.selectionStart != null || t instanceof HTMLTextAreaElement;
}
function K(t, s, f, r) {
  if (!t || !s || !s.scrollTo)
    return;
  let c = t.scrollLeft, n = t.scrollTop;
  const L = t.clientWidth < t.scrollWidth, S = t.clientHeight < t.scrollHeight;
  if (L && r !== "vertical") {
    const o = p(t, s, "left"), l = e(t), i = e(s);
    f === "ltr" && (o + s.offsetWidth + i.scrollMarginRight > t.scrollLeft + t.clientWidth - l.scrollPaddingRight ? c = o + s.offsetWidth + i.scrollMarginRight - t.clientWidth + l.scrollPaddingRight : o - i.scrollMarginLeft < t.scrollLeft + l.scrollPaddingLeft && (c = o - i.scrollMarginLeft - l.scrollPaddingLeft)), f === "rtl" && (o - i.scrollMarginRight < t.scrollLeft + l.scrollPaddingLeft ? c = o - i.scrollMarginLeft - l.scrollPaddingLeft : o + s.offsetWidth + i.scrollMarginRight > t.scrollLeft + t.clientWidth - l.scrollPaddingRight && (c = o + s.offsetWidth + i.scrollMarginRight - t.clientWidth + l.scrollPaddingRight));
  }
  if (S && r !== "horizontal") {
    const o = p(t, s, "top"), l = e(t), i = e(s);
    o - i.scrollMarginTop < t.scrollTop + l.scrollPaddingTop ? n = o - i.scrollMarginTop - l.scrollPaddingTop : o + s.offsetHeight + i.scrollMarginBottom > t.scrollTop + t.clientHeight - l.scrollPaddingBottom && (n = o + s.offsetHeight + i.scrollMarginBottom - t.clientHeight + l.scrollPaddingBottom);
  }
  t.scrollTo({
    left: c,
    top: n,
    behavior: "auto"
  });
}
function p(t, s, f) {
  const r = f === "left" ? "offsetLeft" : "offsetTop";
  let c = 0;
  for (; s.offsetParent && (c += s[r], s.offsetParent !== t); )
    s = s.offsetParent;
  return c;
}
function e(t) {
  const s = getComputedStyle(t);
  return {
    scrollMarginTop: parseFloat(s.scrollMarginTop) || 0,
    scrollMarginRight: parseFloat(s.scrollMarginRight) || 0,
    scrollMarginBottom: parseFloat(s.scrollMarginBottom) || 0,
    scrollMarginLeft: parseFloat(s.scrollMarginLeft) || 0,
    scrollPaddingTop: parseFloat(s.scrollPaddingTop) || 0,
    scrollPaddingRight: parseFloat(s.scrollPaddingRight) || 0,
    scrollPaddingBottom: parseFloat(s.scrollPaddingBottom) || 0,
    scrollPaddingLeft: parseFloat(s.scrollPaddingLeft) || 0
  };
}
export {
  H as A,
  I as C,
  g as E,
  a as H,
  Y as M,
  A as S,
  w as V,
  E as a,
  h as b,
  T as c,
  R as d,
  d as e,
  P as f,
  _ as g,
  M as h,
  F as i,
  K as s
};
